import React, { CSSProperties, ReactNode } from 'react';
import { Add, Remove } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import { FormSectionProps } from '../../types';

interface Props extends Pick<FormSectionProps, 'sectionName' | 'handleUpdateCollapse' | 'handleUpdateOpenStatus'> {
  name: string;
  sx?: CSSProperties;
  isSectionOpen?: boolean;
  extraAction?: ReactNode;
  isSectionCollapsed?: boolean;
}

export const FormSectionHeader = ({
  name,
  sectionName,
  extraAction,
  handleUpdateCollapse,
  isSectionOpen = true,
  handleUpdateOpenStatus,
  isSectionCollapsed = false,
  sx = {},
}: Props) => (
  <Box style={sx} className="sectionHeader">
    <Box className="collapse">
      {!!handleUpdateOpenStatus && (
        <IconButton
          size="small"
          sx={{ padding: '0.25rem' }}
          onClick={() => handleUpdateOpenStatus(sectionName, !isSectionOpen)}
        >
          {isSectionOpen ? <Remove fontSize="small" /> : <Add fontSize="small" />}
        </IconButton>
      )}

      {!!handleUpdateCollapse && (
        <IconButton
          size="small"
          sx={{ padding: '0.25rem' }}
          onClick={() => handleUpdateCollapse(sectionName, !isSectionCollapsed)}
        >
          {isSectionCollapsed ? <Add fontSize="small" /> : <Remove fontSize="small" />}
        </IconButton>
      )}

      {name && (
        <Typography component="span" variant="subtitle2">
          {name}
        </Typography>
      )}
    </Box>

    {extraAction && extraAction}
  </Box>
);
